import { environment } from '../../environments/environment';
import { SessionStorageService } from '../services/session-storage.service';

const partnerRouteBase = 'partner';

export function isPartnerRoute(hash: string): boolean {
  const normalized = (hash || '').replace(/^[#/]+/, '').split('?')[0].toLowerCase();

  return normalized === partnerRouteBase || normalized.startsWith(`${partnerRouteBase}/`);
}

export function buildLaunchpadCommandUrl(partnerId?: number): string {
  const baseUrl = environment.urlConfig.launchpadCommandUrl;

  return partnerId ? `${baseUrl}/?partnerId=${partnerId}` : baseUrl;
}

export function redirectToLaunchpadCommand(sessionStorageService: SessionStorageService): void {
  sessionStorageService.getPartner().subscribe(partner => {
    window.location.replace(buildLaunchpadCommandUrl(partner?.PartnerId));
  });
}
